import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
const faqs = [{
  question: "What is the maximum guest capacity at VOW?",
  answer: "Our grand ballroom and outdoor ceremony spaces are designed to comfortably accommodate up to 300 guests, while still offering an intimate atmosphere for smaller, curated gatherings."
}, {
  question: "Do you offer in-house catering and design services?",
  answer: "Yes, VOW provides a full-service experience. Our high-end catering team crafts bespoke menus, and our dedicated event designers work closely with you to bring your unique aesthetic vision to life."
}, {
  question: "Can we host both the ceremony and reception on-site?",
  answer: "Absolutely. Our estate features a picturesque ceremony garden and versatile indoor/outdoor transition spaces, allowing for a seamless flow from your vows to the final dance of the evening."
}, {
  question: "Is the venue available for multi-day celebrations?",
  answer: "We offer exclusive weekend packages that allow couples to host rehearsal dinners, the wedding day, and a farewell brunch, ensuring a relaxed and luxurious experience for you and your guests."
}, {
  question: "What is included in the venue rental fee?",
  answer: "Our comprehensive rental includes exclusive use of the estate, professional event coordination, luxury suite access for the wedding party, and our signature contemporary décor elements."
}];
export default function CommonInquiries() {
  return <section data-section-id="222448" id="common-inquiries" className="bg-background text-foreground py-16 md:py-24 lg:py-32">
      <div className="container mx-auto px-4 md:px-6 max-w-3xl">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-default font-medium tracking-tight text-primary mb-4">
            Common Inquiries
          </h2>
          <p className="text-lg font-sans text-muted-foreground max-w-2xl mx-auto">
            Refining the details of your celebration. Explore our most frequent questions to begin planning your timeless event.
          </p>
        </div>

        <div className="bg-card border border-border rounded-md shadow-md p-4 md:p-8">
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((faq, index) => <AccordionItem key={index} value={`item-${index}`} data-index={index} className="border-border">
                <AccordionTrigger className="text-left font-default text-xl md:text-2xl font-normal text-primary hover:text-secondary hover:no-underline transition-colors py-6">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground font-sans text-base leading-relaxed pb-6">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>
      </div>
    </section>;
}